export enum LoginType {
  Social = 'social',
  Securities = 'securities',
}
